import RankTwelve from '@assets/icons/rank-twelve.svg'
import { Icon } from './Icon'

export const RankTwelveIcon = Icon(RankTwelve)
